$(document).ready(function () {
    var btt = $("#b_t_top");

    $(window).scroll(function () {
        if ($(window).scrollTop() > 300) {
            btt.addClass("show");
        } else {
            btt.removeClass("show");
        }
    });
    btt.on("click", function (e) {
        e.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, "300");
    });

    var menuLink = $(".navigate .menu_link");
    var navigacja = $(".navigate");
    var burger = $("#burger");
    burger.click(function (event) {
        burger.toggleClass("open");
        if (burger.hasClass("open")) {
            navigacja.slideDown(400, function () {});
        } else {
            navigacja.slideUp(400, function () {});
            menuLink.removeClass("active");
        }
    });

    var width = $(window).width();

    if ($(".transport_links_slider").length) {
        if (width <= 992) {
            var transport_links_slider = tns({
                container: ".transport_links_slider",
                items: 1,
                slideBy: 1,
                gutter: 20,
                loop: false,
                controls: false,
                speed: 800,
                navContainer: ".transport_links_slider_nav",
            });

            var slideHeight = $(".transport_links_slider").height();
            $(".transport_links_slider .slide").css("height", slideHeight);
        }
    }

    if ($("#natureSlider").length) {
        if (width <= 992) {
            var natureSlider = tns({
                container: "#natureSlider",
                items: 1,
                slideBy: 1,
                gutter: 20,
                loop: false,
                controls: false,
                speed: 800,
                navContainer: ".natureSlider_nav",
            });

            var slideHeight = $("#natureSlider").height();
            $("#natureSlider .slide").css("height", slideHeight);
        }
    }

    if (width <= 992) {
        $(".fleet_card .txt_wrapper").click(function () {
            $(this).find(".txt_opacity").slideToggle();
        });
    }

    function IsEmail(email) {
        var regex =
            /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }

    function validatePhone(txtPhone) {
        var regex = /^[0-9]+$/;
        return regex.test(txtPhone);
    }

    $("#contactForm").submit(function (e) {
        e.preventDefault();
        var lang = $("html").attr("lang");
        $(".is-invalid").removeClass("is-invalid");
        $(".is-valid").removeClass("is-valid");
        $(".invalid-feedback").empty();
        var firstname = $("#formContactFirstname").val();
        var errors = 0;
        $(".contactForm-register-firstname .invalid-feedback").empty();
        if (!firstname) {
            $("#formContactFirstname").addClass("is-invalid");
            errors = 1;
            if (lang == "pl") {
                $(".contactForm-register-firstname .invalid-feedback").html(
                    "<p>To pole jest wymagane</p>"
                );
            } else {
                $(".contactForm-register-firstname .invalid-feedback").html(
                    "<p>This field is required</p>"
                );
            }
        } else {
            if (firstname.length < 3) {
                $("#formContactFirstname").addClass("is-invalid");
                errors = 1;
                if (lang == "pl") {
                    $(".contactForm-register-firstname .invalid-feedback").html(
                        "<p>Imię musi zawierać minimum trzy litery.</p>"
                    );
                } else {
                    $(".contactForm-register-firstname .invalid-feedback").html(
                        "<p>The name must contain at least three letters.</p>"
                    );
                }
            } else {
                $("#formContactFirstname").removeClass("is-invalid");
                $("#formContactFirstname").addClass("is-valid");
            }
        }

        var lastname = $("#formContactLastname").val();
        $(".contactForm-register-lastname .invalid-feedback").empty();
        if (!lastname) {
            $("#formContactLastname").addClass("is-invalid");
            errors = 1;
            if (lang == "pl") {
                $(".contactForm-register-lastname .invalid-feedback").html(
                    "<p>To pole jest wymagane</p>"
                );
            } else {
                $(".contactForm-register-lastname .invalid-feedback").html(
                    "<p>This field is required</p>"
                );
            }
        } else {
            if (lastname.length < 3) {
                $("#formContactLastname").addClass("is-invalid");
                errors = 1;
                if (lang == "pl") {
                    $(".contactForm-register-lastname .invalid-feedback").html(
                        "<p>Nazwisko musi zawierać minimum trzy litery.</p>"
                    );
                } else {
                    $(".contactForm-register-lastname .invalid-feedback").html(
                        "<p>The name must contain at least three letters.</p>"
                    );
                }
            } else {
                $("#formContactLastname").removeClass("is-invalid");
                $("#formContactLastname").addClass("is-valid");
            }
        }

        var email = $("#formContactEmail").val();
        if (email) {
            if (IsEmail(email)) {
                $("#formContactEmail").removeClass("is-invalid");
                $("#formContactEmail").addClass("is-valid");
            } else {
                $("#formContactEmail").addClass("is-invalid");
                if (lang == "pl") {
                    $(".contactForm-register-email .invalid-feedback").html(
                        "<p>Wpisz poprawny adres e-mail</p>"
                    );
                } else {
                    $(".contactForm-register-email .invalid-feedback").html(
                        "<p>Enter a valid email address</p>"
                    );
                }

                errors = 1;
            }
        } else {
            $("#formContactEmail").addClass("is-invalid");
            if (lang == "pl") {
                $(".contactForm-register-email .invalid-feedback").html(
                    "<p>Pole jest wymagane</p>"
                );
            } else {
                $(".contactForm-register-email .invalid-feedback").html(
                    "<p>This field is required</p>"
                );
            }

            errors = 1;
        }

        var phone = $("#formContactPhone").val();
        if (phone) {
            if (phone.length < 7) {
                $("#formContactPhone").addClass("is-invalid");
                if (lang == "pl") {
                    $(".contactForm-register-phone .invalid-feedback").html(
                        "<p>Podany numer telefonu jest za krótki</p>"
                    );
                } else {
                    $(".contactForm-register-phone .invalid-feedback").html(
                        "<p>The phone number provided is too short</p>"
                    );
                }

                errors = 1;
            } else {
                if (!validatePhone(phone)) {
                    $("#formContactPhone").addClass("is-invalid");
                    if (lang == "pl") {
                        $(".contactForm-register-phone .invalid-feedback").html(
                            "<p>Wpisz poprawny 9-cyfrowy numer telefonu</p>"
                        );
                    } else {
                        $(".contactForm-register-phone .invalid-feedback").html(
                            "<p>Enter the correct 9-digit phone number</p>"
                        );
                    }

                    errors = 1;
                } else {
                    $("#formContactPhone").removeClass("is-invalid");
                    $("#formContactPhone").addClass("is-valid");
                }
            }
        }
        var question = $("#formContactQuestion").val();
        $(".contactForm-register-question .invalid-feedback").empty();
        if (!question) {
            $("#formContactQuestion").addClass("is-invalid");
            errors = 1;
            if (lang == "pl") {
                $(".contactForm-register-question .invalid-feedback").html(
                    "<p>To pole jest wymagane</p>"
                );
            } else {
                $(".contactForm-register-question .invalid-feedback").html(
                    "<p>This field is required</p>"
                );
            }
        } else {
            if (question.length < 3) {
                $("#formContactQuestion").addClass("is-invalid");
                errors = 1;
                if (lang == "pl") {
                    $(".contactForm-register-question .invalid-feedback").html(
                        "<p>Pytanie musi zawierać minimum trzy znaki.</p>"
                    );
                } else {
                    $(".contactForm-register-question .invalid-feedback").html(
                        "<p>The question must contain a minimum of three characters.</p>"
                    );
                }
            } else {
                $("#formContactQuestion").removeClass("is-invalid");
                $("#formContactQuestion").addClass("is-valid");
            }
        }

        var agree1 = $("#formContactAgreeRegulations1").prop("checked");
        console.log(agree1);
        if (!agree1) {
            $("#formContactAgreeRegulations1").addClass("is-invalid");
            if (lang == "pl") {
                $(".invalid-feedback.contactForm-agree-regulations1")
                    .html("<p>To pole jest wymagane</p>")
                    .show();
            } else {
                $(".invalid-feedback.contactForm-agree-regulations1")
                    .html("<p>This field is required</p>")
                    .show();
            }

            errors = 1;
        } else {
            $("#formContactAgreeRegulations1").removeClass("is-invalid");
            $(".invalid-feedback.contactForm-agree-regulations1")
                .empty()
                .hide();
            agree1 = 1;
        }

        var agreeVal1 = 0;

        if (agree1) {
            agreeVal1 = 1;
        }

        var token = $("input[name=_token]").val();
        console.log(errors);
        var form = $(this);
        var actionUrl = form.attr("action");

        if (errors == 0) {
            $.ajax({
                url: actionUrl,
                method: "post",
                dataType: "json",
                data: {
                    _token: token,
                    firstname: firstname,
                    lastname: lastname,
                    email: email,
                    phone: phone,
                    question: question,
                    agree_regulations1: agreeVal1,
                },
                success: function (result) {
                    if (result.success == 1) {
                        $("#exampleModal").modal({
                            keyboard: false,
                            backdrop: "static",
                        });
                        $("#exampleModal").modal("show");
                        $("#formContactFirstname").val("");
                        $("#formContactLastname").val("");
                        $("#formContactEmail").val("");
                        $("#formContactPhone").val("");
                        $("#formContactQuestion").val("");
                        $("#formContactAgreeRegulations1").prop(
                            "checked",
                            false
                        );
                        $(".is-valid").removeClass("is-valid");
                        $(".invalid-feedback").empty();
                    } else {
                        alert("Zapis nie powiódł się. Spróbuj ponownie");
                    }
                },
            });
        }
    });
    $("#formContactQuestion").on("input", function () {
        if ($(this).val().length > 300) {
            $(this).val($(this).val().substring(0, 300));
        }

        if (lang == "pl") {
            $("#formContactQuestionHelp").text(
                `Wykorzystano ${$(this).val().length}/300 znaków`
            );
        } else {
            $("#formContactQuestionHelp").text(
                `Used ${$(this).val().length}/300 signs`
            );
        }
    });

    $("#formCareer").submit(function (e) {
        e.preventDefault();
        var lang = $("html").attr("lang");
        $(".is-invalid").removeClass("is-invalid");
        $(".is-valid").removeClass("is-valid");
        $(".invalid-feedback").empty();
        var firstname = $("#formCareerFirstname").val();
        var errors = 0;
        $(".contactForm-career-firstname .invalid-feedback").empty();
        if (!firstname) {
            $("#formCareerFirstname").addClass("is-invalid");
            errors = 1;
            if (lang == "pl") {
                $(".contactForm-career-firstname .invalid-feedback").html(
                    "<p>To pole jest wymagane</p>"
                );
            } else {
                $(".contactForm-career-firstname .invalid-feedback").html(
                    "<p>This field is required</p>"
                );
            }
        } else {
            if (firstname.length < 3) {
                $("#formCareerFirstname").addClass("is-invalid");
                errors = 1;
                if (lang == "pl") {
                    $(".contactForm-career-firstname .invalid-feedback").html(
                        "<p>Imię musi zawierać minimum trzy litery.</p>"
                    );
                } else {
                    $(".contactForm-career-firstname .invalid-feedback").html(
                        "<p>The name must contain at least three letters.</p>"
                    );
                }
            } else {
                $("#formCareerFirstname").removeClass("is-invalid");
                $("#formCareerFirstname").addClass("is-valid");
            }
        }

        var lastname = $("#formCareerLastname").val();
        $(".contactForm-career-lastname .invalid-feedback").empty();
        if (!lastname) {
            $("#formCareerLastname").addClass("is-invalid");
            errors = 1;
            if (lang == "pl") {
                $(".contactForm-career-lastname .invalid-feedback").html(
                    "<p>To pole jest wymagane</p>"
                );
            } else {
                $(".contactForm-career-lastname .invalid-feedback").html(
                    "<p>This field is required</p>"
                );
            }
        } else {
            if (lastname.length < 3) {
                $("#formCareerLastname").addClass("is-invalid");
                errors = 1;
                if (lang == "pl") {
                    $(".contactForm-career-lastname .invalid-feedback").html(
                        "<p>Nazwisko musi zawierać minimum trzy litery.</p>"
                    );
                } else {
                    $(".contactForm-career-lastname .invalid-feedback").html(
                        "<p>The name must contain at least three letters.</p>"
                    );
                }
            } else {
                $("#formCareerLastname").removeClass("is-invalid");
                $("#formCareerLastname").addClass("is-valid");
            }
        }

        var email = $("#formCareerEmail").val();
        if (email) {
            if (IsEmail(email)) {
                $("#formCareerEmail").removeClass("is-invalid");
                $("#formCareerEmail").addClass("is-valid");
            } else {
                $("#formCareerEmail").addClass("is-invalid");
                if (lang == "pl") {
                    $(".contactForm-career-email .invalid-feedback").html(
                        "<p>Wpisz poprawny adres e-mail</p>"
                    );
                } else {
                    $(".contactForm-career-email .invalid-feedback").html(
                        "<p>Enter a valid email address</p>"
                    );
                }

                errors = 1;
            }
        } else {
            $("#formCareerEmail").addClass("is-invalid");
            if (lang == "pl") {
                $(".contactForm-career-email .invalid-feedback").html(
                    "<p>Pole jest wymagane</p>"
                );
            } else {
                $(".contactForm-career-email .invalid-feedback").html(
                    "<p>This field is required</p>"
                );
            }

            errors = 1;
        }

        var phone = $("#formCareerPhone").val();
        if (phone) {
            if (phone.length < 7) {
                $("#formCareerPhone").addClass("is-invalid");
                if (lang == "pl") {
                    $(".contactForm-career-phone .invalid-feedback").html(
                        "<p>Podany numer telefonu jest za krótki</p>"
                    );
                } else {
                    $(".contactForm-career-phone .invalid-feedback").html(
                        "<p>The phone number provided is too short</p>"
                    );
                }

                errors = 1;
            } else {
                if (!validatePhone(phone)) {
                    $("#formCareerPhone").addClass("is-invalid");
                    if (lang == "pl") {
                        $(".contactForm-career-phone .invalid-feedback").html(
                            "<p>Wpisz poprawny 9-cyfrowy numer telefonu</p>"
                        );
                    } else {
                        $(".contactForm-career-phone .invalid-feedback").html(
                            "<p>Enter the correct 9-digit phone number</p>"
                        );
                    }

                    errors = 1;
                } else {
                    $("#formCareerPhone").removeClass("is-invalid");
                    $("#formCareerPhone").addClass("is-valid");
                }
            }
        }
        var question = $("#formCareerQuestion").val();
        $(".contactForm-career-question .invalid-feedback").empty();
        if (!question) {
            $("#formCareerQuestion").addClass("is-invalid");
            errors = 1;
            if (lang == "pl") {
                $(".contactForm-career-question .invalid-feedback").html(
                    "<p>To pole jest wymagane</p>"
                );
            } else {
                $(".contactForm-career-question .invalid-feedback").html(
                    "<p>This field is required</p>"
                );
            }
        } else {
            if (question.length < 3) {
                $("#formCareerQuestion").addClass("is-invalid");
                errors = 1;
                if (lang == "pl") {
                    $(".contactForm-career-question .invalid-feedback").html(
                        "<p>Pytanie musi zawierać minimum trzy znaki.</p>"
                    );
                } else {
                    $(".contactForm-career-question .invalid-feedback").html(
                        "<p>The question must contain a minimum of three characters.</p>"
                    );
                }
            } else {
                $("#formCareerQuestion").removeClass("is-invalid");
                $("#formCareerQuestion").addClass("is-valid");
            }
        }
        var position = $("#formCareerPosition").val();
        $(".contactForm-career-position .invalid-feedback").empty();
        if (!position) {
            $("#formCareerPosition").addClass("is-invalid");
            errors = 1;
            if (lang == "pl") {
                $(".contactForm-career-position .invalid-feedback").html(
                    "<p>Wybierz stanowisko</p>"
                );
            } else {
                $(".contactForm-career-position .invalid-feedback").html(
                    "<p>Select a position</p>"
                );
            }
        } else {
            $("#formCareerPosition")
                .removeClass("is-invalid")
                .addClass("is-valid");
        }

        var file = $("#formCareerCV")[0].files[0];
        $(".contactForm-career-file .invalid-feedback").empty();

        if (!file) {
            $("#formCareerCV").addClass("is-invalid");
            errors = 1;
            if (lang == "pl") {
                $(".contactForm-career-file .invalid-feedback").html(
                    "<p>Załącz plik CV</p>"
                );
            } else {
                $(".contactForm-career-file .invalid-feedback").html(
                    "<p>Attach your CV</p>"
                );
            }
        } else {
            var allowedExtensions = ["pdf", "doc", "docx"];
            var fileExtension = file.name.split(".").pop().toLowerCase();
            if (
                !allowedExtensions.includes(fileExtension) ||
                file.size > 5 * 1024 * 1024
            ) {
                $("#formCareerCV").addClass("is-invalid");
                errors = 1;
                if (lang == "pl") {
                    $(".contactForm-career-file .invalid-feedback").html(
                        "<p>Plik musi być PDF/DOC/DOCX i nie większy niż 5MB</p>"
                    );
                } else {
                    $(".contactForm-career-file .invalid-feedback").html(
                        "<p>File must be PDF/DOC/DOCX and under 5MB</p>"
                    );
                }
            } else {
                $("#formCareerCV")
                    .removeClass("is-invalid")
                    .addClass("is-valid");
            }
        }
        var agree1 = $("#formCareerAgreeRegulations1").prop("checked");
        console.log(agree1);
        if (!agree1) {
            $("#formCareerAgreeRegulations1").addClass("is-invalid");
            if (lang == "pl") {
                $(".invalid-feedback.contactForm-agree-regulations1")
                    .html("<p>To pole jest wymagane</p>")
                    .show();
            } else {
                $(".invalid-feedback.contactForm-agree-regulations1")
                    .html("<p>This field is required</p>")
                    .show();
            }

            errors = 1;
        } else {
            $("#formCareerAgreeRegulations1").removeClass("is-invalid");
            $(".invalid-feedback.contactForm-agree-regulations1")
                .empty()
                .hide();
            agree1 = 1;
        }

        var agreeVal1 = 0;

        if (agree1) {
            agreeVal1 = 1;
        }

        var token = $("input[name=_token]").val();
        console.log(errors);
        var form = $(this);
        var actionUrl = form.attr("action");

        if (errors == 0) {
            var formData = new FormData();
            formData.append("_token", token);
            formData.append("firstname", firstname);
            formData.append("lastname", lastname);
            formData.append("email", email);
            formData.append("phone", phone);
            formData.append("question", question);
            formData.append("position", position);
            formData.append("cv", file);
            formData.append("agree_regulations1", agreeVal1);

            $.ajax({
                url: actionUrl,
                method: "POST",
                dataType: "json",
                processData: false,
                contentType: false,
                data: formData,
                success: function (result) {
                    if (result.success == 1) {
                        $("#exampleModal")
                            .modal({ keyboard: false, backdrop: "static" })
                            .modal("show");
                        $("#formCareer")[0].reset();
                        $(".is-valid").removeClass("is-valid");
                        $(".invalid-feedback").empty();
                    } else {
                        alert("Zapis nie powiódł się. Spróbuj ponownie");
                    }
                },
            });
        }
    });
});
